// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__o4FuG","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1-hEG"};